<div
    class="flex w-full flex-col lg:max-h-100 lg:min-h-100 lg:flex-row xl:max-h-120 xl:min-h-120 2xl:max-h-148 2xl:min-h-148"
    [style.background]="'linear-gradient(0deg, #00a4c1 77.48%, #006c80 100%)'"
>
    <div class="flex w-full items-center justify-start lg:order-2 lg:w-1/2">
        <div class="mt-8 flex w-full max-w-150 flex-col px-4 lg:mt-0 lg:px-0">
            <h1 class="text-headline-large lg:text-display-small xl:text-display-large text-left text-white 2xl:mb-5">
                {{ headerBlock().translations_refs | getTranslation: "title" }}
            </h1>
            <p class="text-title-small lg:text-body-medium xl:text-title-medium text-left text-white">
                {{ headerBlock().translations_refs | getTranslation: "subtitle" }}
            </p>
        </div>
    </div>

    <div
        class="mt-12 flex w-full items-end justify-center lg:order-1 lg:mt-0 lg:max-h-100 lg:min-h-100 lg:w-1/2 xl:max-h-120 xl:min-h-120 2xl:max-h-148 2xl:min-h-148"
    >
        @if (headerBlock().image) {
            <img
                width="1000"
                height="1000"
                draggable="false"
                class="w-fit object-contain"
                [ngSrc]="headerBlock().image | getDirectusImage"
                [alt]="headerBlock().translations_refs | getTranslation: 'title'"
                priority
            />
        }
    </div>
</div>
